<svg class="{$$props.class}" viewBox="0 0 384 512">
  <path
    fill="currentColor"
    d="M172.3 501.7C27 291 0 269.4 0 192a192 192 0 11384 0c0 77.4-27 99-172.3
    309.7a24 24 0 01-39.4 0zM192 272a80 80 0 100-160 80 80 0 000 160z" />
</svg>
